import { Skeleton } from 'primereact/skeleton'
import React from 'react'

const SkeletonTable = ({ children, load, height = "100vh", width = "100%" }) => {
    return (
        <>
            {
                load ? <>{children}</> : <Skeleton height={height} width={width} />
            }
        </>
    )
}

export default SkeletonTable
